import CIcon from "@coreui/icons-react";
import { CForm } from "@coreui/react";
import { merge } from "lodash";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { ButtonBasic, ButtonGhost, LoadingSpinner } from "src/components";
import { EsgContainer } from "src/features/esg-survey/components";
import { useToasts, useUpdateDatabase, useValidation } from "src/hooks";
import { useDoc } from "src/hooks/databaseHooks";
import { selectOrgId } from "src/store/projectSelectors";
import AccountForm from "./components/AccountForm";

const EsgAccountPage = ({ isOnboarding = false }) => {
  const respondentId = useSelector(selectOrgId) || "none";

  const formMethods = useForm();
  const surveyPath = ["esg-survey", respondentId];
  const { data: dataDB } = useDoc(surveyPath);

  const { updateDocument } = useUpdateDatabase();

  useEffect(() => {
    if (!dataDB) return;
    formMethods.reset(dataDB);
  }, [dataDB]);

  const { showToast } = useToasts();

  const history = useHistory();

  const onSubmit = async (data) => {
    try {

      await updateDocument(surveyPath, data);

      showToast({ text: "Your data has been saved", type: "success" });
      history.push("/survey");
    } catch (error) {
      console.log(error);
      showToast({ text: "There was an error saving your data", type: "error" });
    }
  };

  const onChange = (e) =>
    formMethods.setValue(e.target.name, e.target.value, { shouldTouch: true });

  const {
    formState: { errors, isSubmitting, touchedFields },
  } = formMethods;

  const isTouched = Object.keys(touchedFields || {}).length > 0;

  const { isEmail, isRequired, isUrl } = useValidation();

  const introSteps = [
    { name: "orgName", options: isRequired },
    { name: "periodFrom", options: isRequired },
    { name: "periodTo", options: isRequired },
    { name: "companyNumber", options: isRequired },
    { name: "country", options: isRequired },
    { name: "materialityAssessment", options: isRequired },
    { name: "legalStructure", options: isRequired },
    {
      name: "email",
      options: merge({}, isRequired, isEmail),
    },
    {
      name: "website",
      options: merge({}, isRequired, isUrl),
    },
  ];

  useEffect(() => {
    introSteps.forEach((step) => {
      formMethods.register(step.name, step.options);
    });
  });

  return (
    <EsgContainer>
      <CForm
        className="w-100"
        onSubmit={formMethods.handleSubmit(onSubmit)}
        noValidate
      >
        <p
          style={{ fontSize: "28px" }}
          className="font-bold text-center text-info mb-4"
        >
          About you
        </p>
        {dataDB ? (
          <AccountForm onChange={onChange} values={dataDB} errors={errors} />
        ) : (
          <LoadingSpinner />
        )}
        <ButtonBasic
          size="lg"
          disabled={!isTouched || isSubmitting}
          type="submit"
        >
          {isSubmitting ? "Saving..." : "Save & Continue"}
        </ButtonBasic>
      </CForm>
      {!isOnboarding && (
        <ButtonGhost
          className="align-self-start d-flex align-items-center summary-btn coreData-intro-back-button"
          onClick={() => {
            history.push("/survey");
          }}
        >
          <CIcon name="cil-arrow-left" />
          <span className="ml-2" style={{ fontSize: "14px" }}>
            Back
          </span>
        </ButtonGhost>
      )}
    </EsgContainer>
  );
};

export default EsgAccountPage;
